import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Table } from 'primeng/table';

@Injectable({
    providedIn: 'root'
})
export class DownloadService {

    navigator: any = navigator;

    constructor(
        private datePipe: DatePipe
    ) {
    }

    resolveFieldData(data, field) {
        if (data && field) {
            if (field.indexOf('.') === -1) {
                return data[field];
            }
            else {
                const fields = field.split('.');
                let value = data;
                for (let i = 0, len = fields.length; i < len; ++i) {
                    if (value == null) {
                        return null;
                    }
                    value = value[fields[i]];
                }
                return value;
            }
        }
        else {
            return null;
        }
    }

    exportCSV(name: string, table: Table) {
        const columns = table.columns.filter(col => col.exportable).map(col => { return { title: col.header, dataKey: col.field } });
        const data = table.filteredValue || table.value;
        let csv = '';

        // header
        for (let i = 0; i < columns.length; i++) {
            const column = columns[i];
            if (column.dataKey) {
                csv += '"' + (column.title || column.dataKey) + '"';
                if (i < (columns.length - 1)) {
                    csv += ',';
                }
            }
        }

        // body
        data.forEach((record, i) => {
            csv += '\n';
            for (let j = 0; j < columns.length; j++) {
                const column = columns[j];
                if (column.dataKey) {
                    let cellData = this.resolveFieldData(record, column.dataKey);
                    if (cellData != null) {
                        cellData = String(cellData).replace(/"/g, '""');
                    }
                    else
                        cellData = '';
                    csv += '"' + cellData + '"';
                    if (j < (columns.length - 1)) {
                        csv += ',';
                    }
                }
            }
        });

        const blob = new Blob([csv], {
            type: 'text/csv;charset=utf-8;'
        });

        if (this.navigator.msSaveOrOpenBlob) {
            this.navigator.msSaveOrOpenBlob(blob, name + '_' + this.datePipe.transform(new Date(), 'dd/MM/yyyy') + '.csv');
        }
        else {
            const link = document.createElement('a');
            link.style.display = 'none';
            document.body.appendChild(link);
            if (link.download !== undefined) {
                link.setAttribute('href', URL.createObjectURL(blob));
                link.setAttribute('download', name + '_' + this.datePipe.transform(new Date(), 'dd/MM/yyyy') + '.csv');
                link.click();
            }
            else {
                csv = 'data:text/csv;charset=utf-8,' + csv;
                window.open(encodeURI(csv));
            }
            document.body.removeChild(link);
        }
    }

    exportPdf(name: string, table: Table) {
        const columns = table.columns.filter(col => col.exportable).map(col => { return { title: col.header, dataKey: col.field } });

        import('jspdf').then((jsPDF: any) => {
            import('jspdf-autotable').then(x => {
                const doc = new jsPDF.default('l');
                doc.autoTable({ columns, body: table.filteredValue || table.value });
                doc.save(`${name}_${this.datePipe.transform(new Date(), 'dd/MM/yyyy')}.pdf`);
            })
        })
    }
}
